import { createTheme } from '@material-ui/core/styles';
import { colors } from './colors';
import * as overrides from './overrides';

const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary,
    },
    background: {
      default: colors.mainBg,
    },
  },
  overrides,
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1360,
      xl: 2000,
    },
  },
});

export default theme;
